<template>
  <div class="overlay d-md-none" v-if="showOverlay" @click="openSideBar"></div>
  <div class="sidebar d-md-none" ref="sidebar">
    <div class="navToggler" @click="openSideBar">
      <i class="fa-solid fa-bars"></i>
    </div>

    <nav>
      <router-link :to="{ name: 'home' }" @click="closeAside"
        ><i class="fa-solid fa-house"></i>Home</router-link
      >
      <router-link :to="{ name: 'about' }" @click="closeAside"
        ><i class="fa-solid fa-user"></i>About</router-link
      >
      <router-link :to="{ name: 'certificates' }" @click="closeAside"
        ><i class="fa-solid fa-award"></i>Certificates</router-link
      >
      <router-link :to="{ name: 'works' }" @click="closeAside"
        ><i class="fa fa-briefcase"></i>Works</router-link
      >
      <router-link :to="{ name: 'contact' }" @click="closeAside"
        ><i class="fa fa-comments"></i>Contact</router-link
      >
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showOverlay: false,
    };
  },
  methods: {
    openSideBar() {
      this.$refs.sidebar.classList.toggle("open");
      if (this.$refs.sidebar.classList.contains("open")) {
        this.showOverlay = true;
      } else {
        this.showOverlay = false;
      }
    },
    closeAside() {
      this.openSideBar();
    },
  },
};
</script>

<style lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, 0.4);
  z-index: 99;
}
.sidebar {
  position: fixed;
  height: 100vh;
  z-index: 100;
  width: 220px;
  top: 0;
  right: 0;
  background: var(--bg-black-900);
  display: grid;
  place-content: center;
  transform: translateX(215px);
  transition: all 0.6s ease;
  &.open {
    transform: translateX(0);
  }
  .navToggler {
    border: 1px solid var(--skin-color);
    position: absolute;
    font-size: 2.2rem;
    padding: 10px;
    left: -53px;
    top: 15px;
    color: var(--skin-color);
    cursor: pointer;
    transition: all 0.8s ease;
    &:hover {
      background: var(--skin-color);
      color: #000;
    }
  }
  nav {
    display: flex;
    flex-direction: column;
    gap: 80px;
    a {
      font-size: 1.4rem;
      text-decoration: none;
      color: var(--text-black-900);
      transition: all 0.3s ease;
      padding-bottom: 5px;
      border-bottom: 1px solid #333;
      i {
        margin-right: 20px;
      }
      &:hover {
        color: var(--skin-color);
      }
      &.router-link-exact-active {
        color: var(--skin-color);
      }
    }
  }
}
</style>
